module.exports = __webpack_public_path__ + "static/media/15.e5c2873e.jpg";